import { FadeOutContainer } from 'shared/components/fade-out-container/FadeOutContainer';
import { DonutChartsSection } from './donutCharts';
import { ElumityIsAllYouNeedSection } from './elumityIsAllYouNeed';
import { ExaminationThesisSection } from './examinationThesis';
import { HeroSection } from './hero';
import { JoinUsSection } from './joinUs';
import { KnowledgeHubSection } from './knowledgeHub';
import { SaveTimeSection } from './saveTime';
import { TabsSection } from './tabsSection';
import { YouReadNewSection } from './youReadNewSection';
import { OrganizeDocumentElement } from './organize-your-documents';
import { ReferenceManagement } from './referenceManagement';
import { PublishShareSection } from './publishShare/publish-share';
import { PeerGroups } from './peerGroups/PeerGroups';

export const HomeScreen = () => {
    return (
        <>
            <FadeOutContainer />
            <HeroSection />
            <ElumityIsAllYouNeedSection />
            <OrganizeDocumentElement />
            <ReferenceManagement />
            <PublishShareSection />
            <PeerGroups />
            <DonutChartsSection />
            <SaveTimeSection />
            <TabsSection />
            <KnowledgeHubSection />
            <YouReadNewSection />
            <ExaminationThesisSection />
            <JoinUsSection />
        </>
    );
};
